// cookie.ts (or .js)
export function setCookie(
  name,
  value,
  { days, seconds, path = "/", sameSite = "Lax", secure = true } = {}
) {
  const enc = encodeURIComponent;
  let expires = "";
  if (typeof seconds === "number") {
    expires = `; Max-Age=${seconds}`;
  } else if (typeof days === "number") {
    expires = `; Expires=${new Date(Date.now() + days * 864e5).toUTCString()}`;
  }
  const secureFlag = secure ? "; Secure" : "";
  document.cookie = `${enc(name)}=${enc(
    value
  )}${expires}; Path=${path}; SameSite=${sameSite}${secureFlag}`;
}

export function getCookie(name) {
  const enc = encodeURIComponent;
  const match = document.cookie
    .split("; ")
    .find((row) => row.startsWith(`${enc(name)}=`));
  return match ? decodeURIComponent(match.split("=")[1]) : null;
}

export function deleteCookie(name, path = "/") {
  // Set an expiration in the past -> browser removes it
  document.cookie = `${encodeURIComponent(
    name
  )}=; Expires=Thu, 01 Jan 1970 00:00:00 GMT; Path=${path};`;
}
